var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCrossRedBold = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65364 7L13.6337 3.01994C14.1221 2.53153 14.1221 1.73966 13.6337 1.25085L12.7491 0.366307C12.2607 -0.122102 11.4689 -0.122102 10.9801 0.366307L7 4.34636L3.01994 0.366307C2.53153 -0.122102 1.73966 -0.122102 1.25085 0.366307L0.366307 1.25085C-0.122102 1.73926 -0.122102 2.53114 0.366307 3.01994L4.34636 7L0.366307 10.9801C-0.122102 11.4685 -0.122102 12.2603 0.366307 12.7491L1.25085 13.6337C1.73926 14.1221 2.53153 14.1221 3.01994 13.6337L7 9.65364L10.9801 13.6337C11.4685 14.1221 12.2607 14.1221 12.7491 13.6337L13.6337 12.7491C14.1221 12.2607 14.1221 11.4689 13.6337 10.9801L9.65364 7Z",
    fill: "#F44336"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCrossRedBold);
export default ForwardRef;